import { render, staticRenderFns } from "./CrmFunnelPhase.vue?vue&type=template&id=bf2c83c4&scoped=true&"
import script from "./CrmFunnelPhase.vue?vue&type=script&lang=js&"
export * from "./CrmFunnelPhase.vue?vue&type=script&lang=js&"
import style0 from "./CrmFunnelPhase.vue?vue&type=style&index=0&id=bf2c83c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2c83c4",
  null
  
)

export default component.exports